/**
 * Catalog copy helpers shared by the Supplier & SKU panel (auto-fill) and the
 * confirmed-swap clean-up (useSkuSwapCleanup), which overwrites the product's
 * name and description with the new style's.
 */

// Clean a SanMar catalog product name into a storefront-ready title
// (Jake's exact rule):
//   1. Remove the SKU id wherever it appears in the name. SanMar embeds
//      the SKU at the end (e.g. "Port & Co Core Fleece... PC78H") and
//      sometimes at the start (e.g. "18000 - Gildan Heavy Blend 18000").
//      We strip every whole-word occurrence.
//   2. Trim leading AND trailing non-alphanumeric characters so separators
//      left behind by the SKU strip ("18000 - Gildan..." -> "Gildan...",
//      "- Port & Co..." -> "Port & Co...") disappear.
// Internal punctuation is preserved ("Port & Co" keeps the "&"). Anchoring
// SKU removal on word boundaries avoids clobbering SKUs that are substrings
// of real words (ID="PC78" must not strip the "PC78" inside "EPC78").
export function cleanCatalogName(rawName, skuId) {
  if (typeof rawName !== 'string') return ''
  let out = rawName
  if (skuId) {
    const escapedId = String(skuId).replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    const skuAnywhere = new RegExp(`\\b${escapedId}\\b`, 'gi')
    out = out.replace(skuAnywhere, ' ')
  }
  // Trim leading/trailing non-alphanumeric characters. Unicode-aware so
  // accented product names keep their leading/trailing letters. Collapse
  // internal whitespace introduced by the SKU strip.
  out = out.replace(/\s+/g, ' ')
  out = out.replace(/^[^\p{L}\p{N}]+/u, '').replace(/[^\p{L}\p{N}]+$/u, '')
  return out.trim()
}

// Decode HTML entities (named + numeric) to their characters. Uses the
// browser-standard textarea round-trip: a DETACHED textarea's innerHTML is
// parsed as RCDATA (text-only content model -- tags and scripts do NOT
// execute), and reading .value returns the decoded text. This is the safe
// decode idiom, NOT an XSS vector: the element is never inserted into the
// document and only entity references are resolved. Do not "sanitize" this
// into DOMPurify -- that would strip the very characters we want to keep.
// Decodes EXACTLY once (so "&amp;amp;" -> "&amp;", never "&"), which is the
// desired behavior for singly-encoded supplier copy. Non-strings pass
// through unchanged.
export function decodeHtmlEntities(str) {
  if (typeof str !== 'string' || str === '') return str
  const el = document.createElement('textarea')
  el.innerHTML = str
  return el.value
}
